<template>
  <div id="app">
    <v-app>
      <router-view></router-view>
    </v-app>
  </div>
</template>

<script>
import debounce from 'lodash/debounce'
export default {
  data() {
    return {
      lastHeight: 0,
    }
  },
  async created() {
    // 3 accounts
    // localStorage.setItem('user-token', '<paste-a-test-jwt-here>')
    // 2 accounts "twip_admin","twip_fleet"
    // localStorage.setItem('user-token', '<paste-a-test-jwt-here>')
    // 1 account "twip_fleet"
    // localStorage.setItem('user-token', '<paste-a-test-jwt-here>')
    // 0 accounts
    // localStorage.setItem('user-token', '<paste-a-test-jwt-here>')

    // initialize css property --vh for use in mobile device
    const vh = window.innerHeight * 0.01
    // Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty('--vh', `${vh}px`)
    const vhCalc = () => {
      // We execute the same script as before
      const vh = window.innerHeight * 0.01
      document.documentElement.style.setProperty('--vh', `${vh}px`)
    }
    window.addEventListener('resize', debounce(vhCalc, 150))
  },
}
</script>

<style lang="scss">
@import "@/style/colors.scss";

// .v-alert {
//   z-index: 0 !important;
// }

// css to override the vuetify style (not everything we want is possible with the options offers from this lib)
.v-btn:not(.v-btn--icon) {
  text-transform: initial;
  padding: 0 32px;
}
// special shadows
div.v-card,
div.v-sheet.v-card:not(.v-sheet--outlined) {
  box-shadow: 0px 1px 1px -3px rgb(0 0 0 / 18%),
    0px 1px 3px 1px rgb(0 0 0 / 10%), 0px 2px 4px 2px rgb(0 0 0 / 8%);
}
div.v-card--hover:hover,
div.v-sheet.v-card--hover:not(.v-sheet--outlined):hover,
div.v-card--hover:focus,
div.v-sheet.v-card--hover:not(.v-sheet--outlined):focus {
  box-shadow: 0px 3px 3px -3px rgb(0 0 0 / 10%),
    0px 4px 8px 1px rgb(0 0 0 / 10%), 0px 2px 10px 1px rgb(0 0 0 / 8%);
}

// bigger border radius for card
div.v-card,
div.v-sheet.v-card {
  border-radius: 10px;
}

// padding for content in card
.app-block .container {
  padding: 10px 16px;
}

// fix button letter spacing
.v-btn {
  letter-spacing: normal;
}

.border--rounded {
  border-radius: 10px;
}

.app-title {
  font-family: "Nunito";
  color: $app-dark-blue !important;
}

.v-toolbar__content {
  .app-title {
    font-size: 1.5rem;
  }
}

.app-display-1 {
  font-size: 2.125rem !important;
  font-weight: 400 !important;
  line-height: 2.5rem;
  letter-spacing: 0.0073529412em !important;
}

.letter-normal {
  letter-spacing: normal !important;
}
.app-dark-blue {
  background-color: $app-dark-blue !important;
}
.app-dark-blue--text {
  color: $app-dark-blue !important;
}
.app-light-blue {
  background-color: $app-light-blue !important;
}
.app-light-blue--text {
  color: $app-light-blue !important;
}

.app-card-selection {
  overflow-y: hidden !important;
  border: 2px solid white;
  opacity: 0.7;
  cursor: pointer;
}

.app-card-selection--no-opacity {
  overflow-y: hidden !important;
  border: 2px solid white;
}

.app-card-selection--hover:hover {
  opacity: 1;
}

.app-card-selected {
  border: 2px solid $app-dark-blue !important;
  opacity: 1;
}

.app-full-height {
  height: 100vh;
  height: calc(var(--vh, 1vh) * 100);
}

.v-card--link:before {
  background: white !important;
}

.fixed--bottom {
  position: fixed !important;
  width: 100%;
  bottom: 0;
  left: 0;
  z-index: 5;
}

.full-width {
  width: 100%;
}

.background-white {
  background: white;
}

.small-grey-text {
  color: rgba(0, 0, 0, 0.6);
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.375rem;
  letter-spacing: 0.0071428571em;
  font-family: "Roboto";
}

#PaylineWidget .pl-pay-btn {
  background-color: $app-dark-blue;
}
#PaylineWidget .pl-pay-btn:hover {
  background-color: $app-dark-blue;
}
#PaylineWidget .pl-card-logos-container {
  display: none;
}

@media screen and (min-width: 600px) {
  .app-block {
    padding: 12px;
  }

  .fixed--bottom {
    position: relative !important;
    z-index: 0;
  }
}

.v-sheet.v-snack__wrapper {
  border-left: 6px solid !important;
}

.v-alert {
  z-index: 2003 !important;
}

.v-expansion-panel-header__icon {
  margin: auto;
}

.vdp-datepicker__calendar {
  width: 230px !important;
}
</style>
